import ParchmentCard from '@/components/ui/ParchmentCard';
import ProgressBar from '@/components/ui/ProgressBar';
import Button from '@/components/ui/Button';

const typeLabels = { daily: 'Diária', weekly: 'Semanal', permanent: 'Permanente' };
const typeColors = { daily: 'text-energy', weekly: 'text-gem', permanent: 'text-accent' };

const parseRequirement = (requirement) => {
  if (!requirement) return {};
  if (typeof requirement === 'string') {
    try {
      return JSON.parse(requirement);
    } catch {
      return {};
    }
  }
  return requirement;
};

export default function MissionCard({ playerMission, onClaim, claiming }) {
  const { mission, progress = 0, status } = playerMission;
  const requirement = parseRequirement(mission?.requirement);
  const target = requirement.target || 1;
  const pctLabel = `${Math.min(progress, target)} / ${target}`;

  return (
    <ParchmentCard className="mb-3">
      <div className="flex items-start gap-3 text-fg">
        <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl border border-edge bg-surfaceAlt text-2xl">
          📜
        </div>
        <div className="min-w-0 flex-1">
          <div className="mb-1 flex flex-wrap items-center gap-2">
            <span className={`text-xs font-bold ${typeColors[mission?.type] || typeColors.permanent}`}>
              {typeLabels[mission?.type] || 'Missão'}
            </span>
            {status === 'completed' && <span className="rounded-full border border-forest/30 bg-forest/20 px-2 text-xs font-bold text-forest-light">Concluída</span>}
            {status === 'claimed' && <span className="rounded-full bg-surfaceAlt px-2 text-xs font-bold text-muted">Reclamada</span>}
          </div>

          <h3 className="font-urban text-base font-bold leading-tight">{mission?.title}</h3>
          <p className="mb-2 mt-0.5 text-xs text-muted">{mission?.description}</p>

          <ProgressBar value={progress} max={target} color="green" />

          <div className="mt-2 flex items-center justify-between gap-3">
            <div className="text-xs font-bold text-fg/75">
              {pctLabel} · 🪙 {mission?.coinReward || 0} · ⭐ {mission?.xpReward || 0} XP
            </div>
            {status === 'completed' && onClaim && (
              <Button variant="gold" className="px-3 py-1.5 text-xs" disabled={claiming} onClick={() => onClaim(playerMission)}>
                {claiming ? 'A reclamar...' : 'Reclamar'}
              </Button>
            )}
          </div>
        </div>
      </div>
    </ParchmentCard>
  );
}
